
export default function starRating () {
	return {
		restrict: 'E',
		scope: {
			rating: '@',
			showValue: '@',
			value: '@'
		},
		template: require('./star-rating.html'),
		transclude: true,
	}
};

starRating.$inject = [];



// WEBPACK FOOTER //
// ./src/directive/star-rating/star-rating.js